import { Type } from '@angular/core';
import { MessageProvider } from './message-provider.model';
import { ToastProvider } from './toast-provider.model';

export interface CapturumUiConfig {
  messageService?: Type<MessageProvider>;
  toastService?: Type<ToastProvider>;
}
